<template>
  <svg
    viewBox="0 0 42 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    class="animate-cta overflow-visible"
  >
    <path class="arrow" d="M41 100L21 120L0 100" stroke-width="1.5" />
    <path class="line" d="M21 120L21 60" stroke-width="1.5" />
  </svg>
</template>

<style scoped lang="scss">
$animation-duration: 1.75s;

.animate-cta {
  .line {
    opacity: 0;
  }

  &:hover {
    animation:
      cta-initial $animation-duration ease-out,
      $animation-duration cta $animation-duration infinite ease-out;
    transform-origin: bottom;

    .line {
      animation: cta-line $animation-duration infinite ease-in;
    }
  }
}

@keyframes cta-initial {
  0% {
    transform: translateY(0);
    opacity: 1;
  }

  35% {
    opacity: 1;
  }

  50% {
    transform: translateY(10%);
    opacity: 1;
  }

  60% {
    transform: translateY(10%);
    opacity: 1;
  }

  85% {
    opacity: 1;
  }

  85% {
    transform: translateY(20%);
    opacity: 0;
  }

  100% {
    transform: translateY(20%);
    opacity: 0;
  }
}

@keyframes cta {
  0% {
    transform: translateY(0);
    opacity: 0;
  }

  35% {
    opacity: 1;
  }

  50% {
    transform: translateY(10%);
    opacity: 1;
  }

  60% {
    transform: translateY(10%);
    opacity: 1;
  }

  85% {
    opacity: 1;
  }

  85% {
    transform: translateY(20%);
    opacity: 0;
  }

  100% {
    transform: translateY(20%);
    opacity: 0;
  }
}

@keyframes cta-line {
  0% {
    transform: scaleY(0);
    opacity: 0;
    transform-origin: top;
  }

  10% {
    transform: scaleY(0);
    opacity: 0;
    transform-origin: top;
  }

  50% {
    transform: scaleY(1);
    opacity: 1;
  }

  60% {
    transform: scaleY(1);
    opacity: 1;
    transform-origin: top;
  }

  61% {
    transform-origin: bottom;
  }

  85% {
    transform: scaleY(0);
    transform-origin: bottom;
    opacity: 1;
  }

  100% {
    transform: scaleY(0);
    transform-origin: bottom;
    opacity: 1;
  }
}
</style>
